import { useAtomValue } from "jotai";
import {
    activeVoteVisibilityAtom,
    startVoteActiveTabAtom,
    startVoteVisibilityAtom,
} from "../AppStore";
import styles from "./HeaderBar.module.css";
import { LeftBar } from "./LeftBar";
import { RightBar } from "./RightBar";

export const HeaderBar = () => {
    const isHeaderVisible = !useAtomValue(activeVoteVisibilityAtom);
    const isStartVoteVisible = useAtomValue(startVoteVisibilityAtom);
    const startVoteActiveTab = useAtomValue(startVoteActiveTabAtom);

    const isLeftBarVisible = !(isStartVoteVisible && startVoteActiveTab === "new");

    if (isHeaderVisible) {
        return (
            <header className={styles.header}>
                {isLeftBarVisible && <LeftBar className={styles.left} />}

                <RightBar className={styles.right} />
            </header>
        );
    }

    return null;
};
